import config from './config'
import accessoryDetails from './component'

const module = angular.module('accessory-details', [])

module.config(config).component('accessoryDetails', accessoryDetails)

export default module.name
